"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Branch = _interopRequireDefault(require("@rsuite/icon-font/lib/flow/Branch"));

// Generated by script, don't edit it please.
var Branch = (0, _createSvgIcon["default"])({
  as: _Branch["default"],
  ariaLabel: 'branch',
  category: 'flow',
  displayName: 'Branch'
});
var _default = Branch;
exports["default"] = _default;
module.exports = exports.default;